import type { FC } from "react";

import { cn } from "@/lib/utils";

import { ASSISTANT_PERSONA } from "../types";
import { AgentMoodAvatar } from "./AgentMoodAvatar";

type Props = {
  name?: string;
  className?: string;
};

/** Casey's mark and name over a reply turn, once per turn. */
export const AssistantByline: FC<Props> = ({
  name = ASSISTANT_PERSONA,
  className
}) => (
  <div
    data-testid="assistant-byline"
    className={cn(
      "flex items-center gap-1.5 text-sm font-medium text-fg-2",
      className
    )}
  >
    <AgentMoodAvatar size="xs" agent={{ key: "assistant" }} />
    <span className="min-w-0 truncate">{name}</span>
  </div>
);
